import { FlexSmartCopyQuery, FlexSmartCopyArgs, FlexSmartCopyResponse } from '../../autogenerated/ZoomBridge';

export default class FlexSmartCopyExecutor {
  constructor(fuids, targets, rrns) {
    this.fuids = fuids;
    this.targets = targets;
    this.rrns = rrns;
  }

  run(): Promise<FlexSmartCopyResponse> {
    const query = new FlexSmartCopyQuery();
    const msg = new FlexSmartCopyArgs();
    msg.setSrcFuids(this.fuids);
    msg.setDest(this.targets);
    msg.setSrcRrn(this.rrns);
    query.message = msg;
    return query.run();
  }
}
